import { apiGet, apiPost, apiPut, apiDelete, unwrap } from './apiClient';
import { ResponseDTO, TenantDTO, TenantRequestDTO, MdmDeviceApplication } from '@/types/api';

const BASE = '/api/v1/tenants';

export async function createTenant(request: TenantRequestDTO): Promise<TenantDTO> {
  const res = await apiPost<ResponseDTO<TenantDTO>>(BASE, request);
  return unwrap(res);
}

export async function listTenants(): Promise<TenantDTO[]> {
  const res = await apiGet<ResponseDTO<TenantDTO[]>>(BASE);
  return unwrap(res);
}

export async function getTenant(id: string): Promise<TenantDTO> {
  const res = await apiGet<ResponseDTO<TenantDTO>>(`${BASE}/${id}`);
  return unwrap(res);
}

export async function getTenantsByPartner(partnerId: string): Promise<TenantDTO[]> {
  const res = await apiGet<ResponseDTO<TenantDTO[]>>(`${BASE}/partner/${partnerId}`);
  return unwrap(res);
}

export async function updateTenantStatus(id: string, request: TenantRequestDTO): Promise<TenantDTO> {
  const res = await apiPut<ResponseDTO<TenantDTO>>(`${BASE}/${id}/status`, request);
  return unwrap(res);
}

export async function updateTenantConfig(id: string, request: TenantRequestDTO): Promise<TenantDTO> {
  const res = await apiPut<ResponseDTO<TenantDTO>>(`${BASE}/${id}/config`, request);
  return unwrap(res);
}

export async function getAppInventory(tenantId: string): Promise<MdmDeviceApplication[]> {
  const res = await apiGet<ResponseDTO<MdmDeviceApplication[]>>(`${BASE}/${tenantId}/appinventory`);
  return unwrap(res);
}

// --- APNS Certificate ---

export async function uploadApnsCert(file: File, password: string): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('password', password);
  const res = await apiPost<ResponseDTO<string>>(`${BASE}/apns-certificate`, formData, {
    includeTenantHeader: true,
  });
  return unwrap(res);
}

export async function getApnsCertInfo(): Promise<Record<string, unknown>> {
  const res = await apiGet<ResponseDTO<Record<string, unknown>>>(`${BASE}/apns-certificate`, {
    includeTenantHeader: true,
  });
  return unwrap(res);
}

export async function deleteApnsCert(): Promise<string> {
  const res = await apiDelete<ResponseDTO<null>>(`${BASE}/apns-certificate`, undefined, {
    includeTenantHeader: true,
  });
  return res.message || 'APNS certificate deleted';
}
